var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    {
      staticClass: "md-info md-just-icon md-round",
      attrs: { title: "Generate PDF" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.handleGeneratePdf(_vm.customerInvoiceId)
        },
      },
    },
    [_c("md-icon", [_vm._v("preview")])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }